import Route from '@ember/routing/route'

export default class ManageTeachersNewRoute extends Route {
  queryParams = {
    schoolId: {
      replace: false,
    },
  }
}
